import { render, staticRenderFns } from "./ViewGridIcon.vue?vue&type=template&id=2335149e&"
import script from "./ViewGridIcon.vue?vue&type=script&lang=js&"
export * from "./ViewGridIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports